class VideoPlayer {
    constructor() {
        this.player = null;
        this.isMuted = true;
        this.isPlaying = true;
    }

    /**
     * Инициализация модуля
     * @param {object} options - параметры
     */
    init(options) {
        this.player = options.player;
        this._getElements();
        this._bindEvents();
    }

    /**
     * Получаем элементы со страницы
     * @private
     */
    _getElements() {
        this.videoWrapper = this.player?.querySelector('.j-video-wrapper');
        this.video = this.player?.querySelector('.j-video');
        this.mutedBtn = this.player?.querySelector('.j-video-button-muted');
        this.zoomBtn = this.player?.querySelector('.j-video-button-zoom');
    }

    _bindEvents() {
        this.videoWrapper.addEventListener('click', this._togglePlay.bind(this));
        this.mutedBtn?.addEventListener('click', this._toggleMuted.bind(this));
        this.zoomBtn?.addEventListener('click', () => {
            if (this.video.requestFullscreen) {
                this.video.requestFullscreen();
            } else {
                this.video.webkitEnterFullScreen();
            }
        });
    }

    _togglePlay() {
        this.isPlaying = !this.isPlaying;
        this.isPlaying ? this.video.play() : this.video.pause();
    }

    _toggleMuted() {
        this.isMuted = !this.isMuted;
        this.mutedBtn.classList.toggle('is-active', !this.isMuted);
        this.video.muted = Boolean(this.isMuted);
    }
}


export default VideoPlayer;
